export default {
  title: 'Relatório Assinado / Ativo',
  column_groups: {
    current_period: 'Período atual',
  },
  fields: {
    name: 'Nome',
    area: 'Área',
    signed: 'Assinado',
    live: 'Ativo',
    going_live: 'Em ativação',
    going_live_avg: 'Média de ativação',
    churned: 'Cancelado',
    not_live: 'Inativo',
    live_ratio: 'Rácio ativo',
    avg_mrr: 'MRR médio',
  },
  manager_status_filters: {
    active: 'Ativo',
    inactive: 'Inativo',
    all: 'Todos',
  },
  status_filters: {
    all: 'Todos',
    not_live: 'Inativo',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} restaurante',
    subtitle_other: '{{count}} restaurantes',
    empty: 'Nenhum restaurante encontrado.',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados, atualize a página',
  },
};
